import PageTemplate from "@/components/PageTemplate";
import { DistributionHistory as DistributionHistoryTable } from "@/App/Distributions/History";

export default function DistributionHistory() {
  return (
    <PageTemplate>
      <DistributionHistoryTable />
    </PageTemplate>
  );
}